window.onload = function() {
  // var imgMenu = document.querySelectorAll('.x-menu-type .mega-menu-block .mega-menu-promo-image');
  
  // imgMenu.forEach((el) => {
  //   console.log(el)
  //   el.addEventListener("mouseover", () => {
  //     document.querySelectorAll('.x-menu-type .mega-menu-block.menu-list .x-menu--level-2--list').forEach((obj) => {
  //       obj.classList.remove('active');
  //     });
  //     document.querySelector(`.x-menu-type [data-to=${el.getAttribute('id')}]`).classList.add('active');
  //   });  
  // })

  // var yMenu = document.querySelectorAll('.y-menu-type .mega-menu-block .mega-menu-promo-image');
  
  // yMenu.forEach((el) => {
  //   console.log(el)
  //   el.addEventListener("click", () => {
  //     document.querySelectorAll('.y-menu-type .mega-menu-block.menu-list .y-menu--level-2-list').forEach((obj) => {
  //       obj.classList.remove('active');
  //     });
  //     document.querySelector(`.y-menu-type [data-to=${el.getAttribute('id')}]`).classList.add('active');
  //   });  
  // })
}